import React, { Component } from 'react';
import Point from './point';

class Delivery extends Component {

    constructor(props) {
        super(props)
        this.myRef = React.createRef();
      }

    state = {
        calculating: false,
        calculated: false,
        height: 1000
    }

    componentDidMount() {
        let delivery_body_height = this.myRef.current.clientHeight;
        this.setState({calculated: true, height: delivery_body_height});
        window.addEventListener('resize', () => {
            this.setState({calculating: true}, this.recalculateHeight.bind(this));
        });
    }

    recalculateHeight() {
        let delivery_body_height = this.myRef.current.clientHeight;
        this.setState({calculating: false, height: delivery_body_height});
    }

    render () {

        return (
            <div className={`delivery${this.props.content.accordionOpen ? "" : " is-closed" }${this.state.calculated ? " is-calculated" : "" }${this.state.calculating ? " is-calculating" : "" }`}>
                <div className="delivery_head" onClick={ () => {this.props.onClick(this.props.content.id)}}>
                    <div className="toggleBtn"></div>
                    <h3>ID: {this.props.content.id}</h3>
                    <span className={
                        this.props.content.statusCode === 1 ? (
                            "delivery_status orange"
                          ) : this.props.content.statusCode === 2 || this.props.content.statusCode === 3 ? (
                            "delivery_status blue"
                          ) : this.props.content.statusCode === 4 || this.props.content.statusCode === 9 ? (
                            "delivery_status red"
                          ) : this.props.content.statusCode === 6 || this.props.content.statusCode === 7 || this.props.content.statusCode === 8 ? (
                            "delivery_status green"
                          ) : (
                            "delivery_status"
                          )
                        }
                    >{this.props.content.status.trim()}</span>
                    <span className="delivery_date">{this.props.content.startDateTime.date + " - " + this.props.content.startDateTime.time}</span>
                </div>
                {this.props.content.to
                    ?   <div className="delivery_path">
                            <span>Από: {this.props.content.from}</span>
                            <span>Προς: {this.props.content.to}</span>
                        </div>
                    : ""
                }
                {this.props.content.notes
                    ?   <div className="delivery_notes">
                            <h4>Παρατηρήσεις: </h4>
                            <p>{ this.props.content.notes }</p>
                        </div>
                    : ""
                }
                {/* style={{max-height: this.state.height}} */}
                {/* style={`max-height: ${this.state.height}`} */}
                <div className="delivery_body" ref={this.myRef} style={{maxHeight: this.state.height ? this.state.height + "px" : ""}}>
                    <div className="delivery_body_wrapper">
                        {this.props.content.points.map((key, index) => {
                            return <Point key={"point" + index} content={this.props.content.points[index]} />
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Delivery;